import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Form, Input, Row, Col, Space, Select, Modal, Typography } from "antd";
import Main from "../../../../layout/main/Main";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import {
	AfipCuitInfo,
	AntdButton,
	BlockedData,
	ClientData,
	Container,
	GhostDangerButton,
	GridCol12,
	GridCol4,
	GridCol6,
	InnerForm,
	PageTitle,
	PageWrapper,
	PreviewImage,
	PrimaryActionButton,
	PurpleListBody,
	PurpleListCard,
	PurpleListHeader,
	RightContainer,
	Section,
	SectionCard,
	SectionHeader,
	SectionHeaderAction,
	SectionTitle,
	StatusSelectWrap,
	VerificationBox,
	VerificationData,
	VerificationLabel,
	VerificationRow,
	VerificationText,
	VerificationValue,
	FormGrid,
} from "./styles";
import LoadingSkeleton from "./components/loading-skeleton/LoadingSkeleton";
import DistributorsSelector from "../../../../common/distributos-selector/DistributorsSelector";
import { COLORS, Typo } from "../../../../layout/theme";
import {
	get_client_by_id,
	update_approved,
} from "../../../../../api/endpoints/clients";
import PhoneInput from "../../../../common/phone-input/PhoneInput";
import { create_history_approval } from "../../../../../api/endpoints/historyApprovals";
import { useAuth } from "../../../../../contexts/authContext";
import {
	get_cuit_info,
	send_approved_validation_email,
} from "../../../../../api/endpoints/auth";
import { get_provinces } from "../../../../../api/endpoints/region";
import {
	CloseCircleOutlined,
	CheckCircleOutlined,
	EnvironmentOutlined,
	UserOutlined,
	DownCircleOutlined,
	DownloadOutlined,
	CopyOutlined,
} from "@ant-design/icons";
import { validateCUIT } from "../../../../../utils/cuitValidator";
import { CONSTANTS } from "../../../../../utils/constants";

const { confirm } = Modal;
const { Paragraph } = Typography;
const { Option } = Select;
const GUTTER = 10;

export default function UpdateRequest() {
	const { id } = useParams();
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const { updateRequestValidation, findUserInFirestore } = useAuth();

	const [submitting, setSubmitting] = useState(false);
	const [distributors, setDistributors] = useState(null);
	const [saleDepartments, setSaleDepartments] = useState(null);
	const [initialValues, setInitialValues] = useState(null);
	const [idProvincia, setIdProvincia] = useState(null);
	const [listadoProvincias, setListadoProvincias] = useState(null);
	const [listadoLocalidades, setListadoLocalidades] = useState(null);
	const [provincia, setProvincia] = useState(null);
	const [localidad, setLocalidad] = useState();
	const [imageUrl, setImageUrl] = useState();
	const [stateList, setStateList] = useState([]);
	const [userDataInFirestore, setUserDataInFirestore] = useState(null);
	const [loading, setLoading] = useState(false);
	const [afipData, setAfipData] = useState(null);
	const [isCuitValid, setIsCuitValid] = useState(null);

	const businessName = Form.useWatch("businessName", form);
	const businessAddress = Form.useWatch("address", form);
	const businessPostalCode = Form.useWatch("postalCode", form);

	useEffect(() => {
		const fetch_client_by_id = async () => {
			const data = await get_client_by_id(id);

			const client = {
				name: data.client.name,
				cuit: data.client.cuit,
				address: data.client.address,
				postalCode: data.client.postalCode,
				businessName: data.client.businessName,
				glnAnmat: data.client.glnAnmat,
				isSeller: data.client.isSeller,
				contactEmail: data.client.contactEmail,
				contactFirstName: data.client.contactName.split(/(\s+)/)[0],
				contactLastName: data.client.contactName.split(/(\s+)/)[2],
				phone: data.client.contactPhone.slice(
					3,
					data.client.contactPhone.length,
				),
				phoneAreaCode: data.client.contactPhone.slice(0, 2),
				contactId: data.client.users ? data.client.users[0].id : null,
				provinceName: data.region?.provinceName,
				localityName: data.region?.localityName,
				firstUserApproved: data.client.users
					? data.client.users[0].approved
					: null,
				deleted: data.client.deleted,
				state: data.client.deleted
					? "REJECTED"
					: data.client.users?.[0]?.approved
						? "APPROVED"
						: "PENDING",
			};

			setDistributors(data.distributors);

			setSaleDepartments(
				data.client.saleDepartments?.map((i) => ({
					value: i.saleDepartment.id,
					label: i.saleDepartment.name,
				})),
			);

			setImageUrl(data.client.photoUrl);

			if (!data.client.users[0].approved && !data.client.deleted) {
				setStateList([
					{ id: "APPROVED", name: "Aprobada" },
					{ id: "REJECTED", name: "Rechazada" },
					{ id: "PENDING", name: "Pendiente" },
				]);
			} else {
				setStateList([
					{ id: "APPROVED", name: "Aprobada" },
					{ id: "REJECTED", name: "Rechazada" },
				]);
			}

			const _userFS = await findUserInFirestore(data?.client?.users[0]?.id);
			setUserDataInFirestore(_userFS);
			setInitialValues(client);
		};

		if (id) {
			fetch_client_by_id();
		}
	}, [id, findUserInFirestore]);

	useEffect(() => {
		const fetch_region_1_data = async () => {
			const res = await get_provinces();

			setListadoProvincias(
				res
					.map((p) => ({
						id: p.id,
						name: p.title,
						localities: p.localities.map((l) => ({
							localityId: l.locality.id,
							localityName: l.locality.title,
						})),
					}))
					.sort((a, b) => a.name.localeCompare(b.name)),
			);

			setListadoLocalidades(res.filter((p) => p.id === idProvincia));
		};

		fetch_region_1_data();
	}, [idProvincia]);

	const onFinish = async (values) => {
		const continueWithApproval = async () => {
			try {
				setSubmitting(true);

				const postData = {
					id: id,
					userId: values.contactId,
					approve: values.state === "APPROVED",
					deleted: values.state === "REJECTED",
				};

				const _history = {
					clientId: id,
					userId: values.contactId,
					changedState: values.state,
					approvalStatus: values.state === "APPROVED",
				};

				await update_approved(postData);
				await updateRequestValidation(postData.userId, postData.approve);
				await create_history_approval(_history);
				// if (postData.approve) {
				// 	await send_approved_validation_email(postData.userId);
				// }

				openNotificationWithIcon(
					TYPE.SUCCESS,
					"La farmacia se actualizó con éxito",
				);
				navigate(`/admin/marketRequests`);
			} catch (error) {
				console.log(error);
				openNotificationWithIcon(
					TYPE.ERROR,
					"Error al actualizar la farmacia",
					"Un error ocurrio al intentar actualizar la farmacia, contacte con soporte a soporte@onetransfer.com.",
				);
			} finally {
				setSubmitting(false);
			}
		};

		if (!!isCuitValid) {
			try {
				if (values.state === "PENDING") {
					setSubmitting(false);
					openNotificationWithIcon(
						TYPE.SUCCESS,
						"La farmacia se actualizó con éxito",
					);
					navigate(`/admin/marketRequests`);
					return;
				}

				if (values.state === "APPROVED") {
					confirm({
						title: "Confirmación de aprobación",
						content: (
							<div>
								{isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR && (
									<Paragraph>
										<strong>El Cuit no posee una estructura válida</strong>
									</Paragraph>
								)}
								{isCuitValid === CONSTANTS.CUIT_STRUCTURE_OK &&
									afipData?.condicionIVA !== CONSTANTS.AFIP_STATUS_OK && (
										<Paragraph>
											<strong>
												Este Cuit no corresponde a un Responsable Inscripto
											</strong>
										</Paragraph>
									)}
								{businessName !== afipData?.razonSocial &&
									afipData?.condicionIVA === CONSTANTS.AFIP_STATUS_OK && (
										<Paragraph>
											<strong>Razón Social:</strong> {businessName} <br />
											<strong>Dato Afip:</strong> {afipData?.razonSocial}
										</Paragraph>
									)}
								{businessAddress !== afipData?.fiscalDireccion &&
									afipData?.condicionIVA === CONSTANTS.AFIP_STATUS_OK && (
										<Paragraph>
											<strong>Dirección:</strong> {businessAddress} <br />
											<strong>Dato Afip:</strong> {afipData?.fiscalDireccion}
										</Paragraph>
									)}
								{businessPostalCode !== afipData?.fiscalCodPostal &&
									afipData?.condicionIVA === CONSTANTS.AFIP_STATUS_OK && (
										<Paragraph>
											<strong>CP:</strong> {businessPostalCode} <br />
											<strong>Dato Afip:</strong> {afipData?.fiscalCodPostal}
										</Paragraph>
									)}
								{isCuitValid === CONSTANTS.CUIT_STRUCTURE_OK &&
									afipData?.condicionIVA === CONSTANTS.AFIP_STATUS_OK &&
									businessName === afipData?.razonSocial &&
									businessAddress === afipData?.fiscalDireccion &&
									businessPostalCode === afipData?.fiscalCodPostal && (
										<Paragraph>
											<strong>No hay advertencias</strong>
										</Paragraph>
									)}
							</div>
						),
						okText: "Confirmar",
						okType: "danger",
						cancelText: "Cancelar",
						onOk: continueWithApproval,
						onCancel: () => {
							setSubmitting(false);
							return;
						},
					});
				} else {
					await continueWithApproval();
				}
			} catch (error) {
				console.log(error);
				setSubmitting(false);
			}
		} else {
			alert("Debe validar el Cuit antes de continuar");
			setSubmitting(false);
			return;
		}
	};

	const handleBack = () => {
		confirm({
			title: "¿Seguro que quiere volver sin guardar?",
			icon: <CloseCircleOutlined style={{ color: "red" }} />,
			content:
				"Si regresa sin guardar se perderán los datos que hayan sido modificados",
			okText: "Sí",
			okType: "danger",
			cancelText: "No",
			onOk: () => {
				navigate("/admin/marketRequests");
			},
		});
	};

	const fetch_afip_check = async (cuit) => {
		const data = await get_cuit_info(cuit);
		setAfipData(data?.cuitInfo);
	};

	const handleCuitCheck = () => {
		setLoading(true);
		try {
			if (validateCUIT(initialValues.cuit)) {
				setIsCuitValid(CONSTANTS.CUIT_STRUCTURE_OK);
				fetch_afip_check(initialValues.cuit);
			} else {
				setIsCuitValid(CONSTANTS.CUIT_STRUCTURE_ERROR);
			}
		} catch (error) {
			console.log(error);
			setIsCuitValid(CONSTANTS.CUIT_STRUCTURE_ERROR);
		} finally {
			setLoading(false);
		}
	};

	return (
		<Main>
			<Main.Header>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.BreadcrumbItem>
						<Link to="/admin/marketRequests">Solicitudes</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>
						Editar Solicitud
					</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</Main.Header>

			<Main.Body>
				{!initialValues ? (
					<LoadingSkeleton />
				) : (
					<Form
						form={form}
						name="basic"
						onFinish={onFinish}
						autoComplete="off"
						requiredMark={false}
						layout="vertical"
						initialValues={initialValues}
					>
						<PageWrapper>
							<PageTitle>Editar Solicitud</PageTitle>

							<InnerForm>
								<ClientData>
									<BlockedData>
										<SectionCard>
											<SectionHeader>
												<SectionTitle>
													<CopyOutlined />
													Datos Principales (Farmacia)
												</SectionTitle>
											</SectionHeader>

											<FormGrid>
												<GridCol4>
													<Form.Item label="Nombre" name="name">
														<Input placeholder="Nombre" />
													</Form.Item>
												</GridCol4>

												<GridCol4>
													<Form.Item
														label="CUIT"
														name="cuit"
														help={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "CUIT inválido"
																: afipData
																	? afipData?.condicionIVA ===
																		CONSTANTS.AFIP_STATUS_OK
																		? ""
																		: "No es responsable inscripto"
																	: null
														}
														validateStatus={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "error"
																: afipData
																	? afipData?.condicionIVA ===
																		CONSTANTS.AFIP_STATUS_OK
																		? "success"
																		: "error"
																	: ""
														}
														hasFeedback
													>
														<Input placeholder="CUIT" />
													</Form.Item>
												</GridCol4>

												<GridCol4>
													<Form.Item
														label="Razón Social"
														name="businessName"
														help={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "CUIT inválido"
																: afipData
																	? afipData?.razonSocial === businessName
																		? ""
																		: afipData?.condicionIVA !==
																			  CONSTANTS.AFIP_STATUS_OK
																			? "No es un responsable inscripto"
																			: "No coincide con AFIP"
																	: null
														}
														validateStatus={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "error"
																: afipData
																	? afipData?.razonSocial === businessName
																		? "success"
																		: "error"
																	: ""
														}
														hasFeedback
													>
														<Input placeholder="Razón Social" />
													</Form.Item>
												</GridCol4>
											</FormGrid>
										</SectionCard>

										<SectionCard>
											<SectionHeader>
												<SectionTitle>
													<EnvironmentOutlined />
													Ubicación
												</SectionTitle>
											</SectionHeader>

											<FormGrid>
												<GridCol6>
													<Form.Item
														label="Dirección"
														name="address"
														help={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "CUIT inválido"
																: afipData
																	? afipData?.fiscalDireccion ===
																		businessAddress
																		? ""
																		: afipData?.condicionIVA !==
																			  CONSTANTS.AFIP_STATUS_OK
																			? "No es un responsable inscripto"
																			: "No coincide con AFIP"
																	: null
														}
														validateStatus={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "error"
																: afipData
																	? afipData?.fiscalDireccion ===
																		businessAddress
																		? "success"
																		: "error"
																	: ""
														}
														hasFeedback
													>
														<Input placeholder="Dirección" />
													</Form.Item>
												</GridCol6>

												<GridCol6>
													<Form.Item
														label="Código Postal"
														name="postalCode"
														help={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "CUIT inválido"
																: afipData
																	? afipData?.fiscalCodPostal ===
																		businessPostalCode
																		? ""
																		: afipData?.condicionIVA !==
																			  CONSTANTS.AFIP_STATUS_OK
																			? "No es un responsable inscripto"
																			: "No coincide con AFIP"
																	: null
														}
														validateStatus={
															isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR
																? "error"
																: afipData
																	? afipData?.fiscalCodPostal ===
																		businessPostalCode
																		? "success"
																		: "error"
																	: ""
														}
														hasFeedback
													>
														<Input placeholder="Código Postal" />
													</Form.Item>
												</GridCol6>

												<GridCol6>
													<Form.Item label="Provincia" name="provinceName">
														<Input placeholder="Provincia" />
													</Form.Item>
												</GridCol6>

												<GridCol6>
													<Form.Item label="Localidad" name="localityName">
														<Input placeholder="Localidad" />
													</Form.Item>
												</GridCol6>
											</FormGrid>
										</SectionCard>

										<SectionCard>
											<SectionHeader>
												<SectionTitle>
													<UserOutlined />
													Datos del Representante
												</SectionTitle>
											</SectionHeader>

											<FormGrid>
												<GridCol6>
													<Form.Item
														label="Nombre del representante"
														name="contactFirstName"
													>
														<Input placeholder="Nombre del representante" />
													</Form.Item>
												</GridCol6>

												<GridCol6>
													<Form.Item
														label="Apellido del representante"
														name="contactLastName"
													>
														<Input placeholder="Apellido del representante" />
													</Form.Item>
												</GridCol6>

												<GridCol12>
													<div
														style={{
															fontSize: 16,
															fontWeight: 800,
															color: "#374151",
															marginTop: 4,
															marginBottom: 4,
														}}
													>
														Datos de Contacto Verificados
													</div>
												</GridCol12>

												<GridCol6>
													<Form.Item
														label={
															<Typo
																type={
																	userDataInFirestore?.emailVerified ||
																	userDataInFirestore?.completeUserData
																		? "success"
																		: "warning"
																}
																level={6}
															>
																{userDataInFirestore?.emailVerified ||
																userDataInFirestore?.completeUserData
																	? "Correo de Contacto verificado"
																	: "Correo de Contacto sin verificar"}
															</Typo>
														}
														name="contactEmail"
													>
														<Input placeholder="Correo de Contacto" />
													</Form.Item>
												</GridCol6>

												<GridCol6>
													<PhoneInput
														form={form}
														size="default"
														label="Teléfono de Contacto"
														labelStyle={{
															color: "#6b7280",
															fontWeight: "700",
														}}
													/>
												</GridCol6>

												<Form.Item name="contactId" style={{ display: "none" }}>
													<Input placeholder="Id" />
												</Form.Item>
											</FormGrid>
										</SectionCard>
									</BlockedData>
								</ClientData>

								<PurpleListCard>
									<PurpleListHeader>
										<span>Droguerías Habilitadas</span>
									</PurpleListHeader>
									<PurpleListBody>
										<Form.Item name="distributors" style={{ marginBottom: 0 }}>
											<DistributorsSelector
												onChange={setDistributors}
												initialValues={distributors}
												noBuyer={initialValues.isSeller}
												containerBackground={COLORS.White}
												showHeader={false}
											/>
										</Form.Item>
									</PurpleListBody>
								</PurpleListCard>

								<SectionCard>
									<SectionHeader>
										<SectionTitle>Estado de la Solicitud</SectionTitle>
									</SectionHeader>

									<StatusSelectWrap>
										<Form.Item
											label="Estado de la farmacia"
											name="state"
											rules={[
												{
													required: true,
													message: "Este campo es obligatorio",
												},
											]}
										>
											<Select
												allowClear={true}
												placeholder="Estado de la farmacia"
											>
												{stateList.map((item) => (
													<Option key={item.id} value={item.id}>
														{item.name}
													</Option>
												))}
											</Select>
										</Form.Item>
									</StatusSelectWrap>

									<PrimaryActionButton htmlType="submit" loading={submitting}>
										Guardar Cambios
									</PrimaryActionButton>

									<GhostDangerButton
										type="button"
										onClick={handleBack}
										loading={submitting}
									>
										Volver sin guardar
									</GhostDangerButton>
								</SectionCard>

								<SectionCard>
									<SectionHeader>
										<SectionTitle>Acciones de Verificación</SectionTitle>
									</SectionHeader>

									<VerificationBox>
										<VerificationText>
											Verifique el CUIT del cliente contra el registro oficial
											antes de aprobar.
										</VerificationText>

										<AntdButton
											onClick={handleCuitCheck}
											loading={loading}
											block
										>
											<DownloadOutlined />
											Verificar CUIT
										</AntdButton>

										<AfipCuitInfo>
											{isCuitValid === CONSTANTS.CUIT_STRUCTURE_ERROR && (
												<Typo level={6}>
													No es una estructura de CUIT válida
												</Typo>
											)}

											{isCuitValid === CONSTANTS.CUIT_STRUCTURE_OK &&
												afipData && (
													<VerificationData>
														<VerificationRow>
															<VerificationLabel>Condición</VerificationLabel>
															<VerificationValue>
																<Typo
																	type={
																		afipData.condicionIVA ===
																		CONSTANTS.AFIP_STATUS_OK
																			? "success"
																			: "warning"
																	}
																	level={6}
																>
																	{afipData.condicionIVA}
																</Typo>
															</VerificationValue>
														</VerificationRow>

														<VerificationRow>
															<VerificationLabel>CUIT</VerificationLabel>
															<VerificationValue>
																{afipData.cuit}
															</VerificationValue>
														</VerificationRow>

														<VerificationRow>
															<VerificationLabel>
																Razón Social
															</VerificationLabel>
															<VerificationValue>
																{afipData.razonSocial}
															</VerificationValue>
														</VerificationRow>

														<VerificationRow>
															<VerificationLabel>
																Dirección Fiscal
															</VerificationLabel>
															<VerificationValue>
																{afipData.fiscalDireccion}
															</VerificationValue>
														</VerificationRow>

														<VerificationRow>
															<VerificationLabel>CP Fiscal</VerificationLabel>
															<VerificationValue>
																{afipData.fiscalCodPostal}
															</VerificationValue>
														</VerificationRow>
													</VerificationData>
												)}
										</AfipCuitInfo>
									</VerificationBox>
								</SectionCard>
							</InnerForm>
						</PageWrapper>
					</Form>
				)}
			</Main.Body>
		</Main>
	);
}
